<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="disabled" type="checkbox" [(ngModel)]="fieldOptions.disabled">
    <span><b>Disabled</b></span>
  </label>
</div>